import React from "react";

import Reveal from "../motion/Reveal";
import { Button } from "../ui/primitives";

// The inverted panel. Used twice, for the same reason both times: it is the
// only place on the site where an action is being asked for, and flipping to
// white is how the page says so without a colour it has not earned.
//
// Shared by the home page's "How engagements start" and by the closing CTA on
// every service page.

export default function PanelCta({ title, body, cta }) {
  return (
    <section className="shell py-16 lg:py-[88px]">
      <Reveal>
        <div
          className="panel-inverse flex flex-col gap-8 p-8 sm:p-12 lg:flex-row lg:items-center
                     lg:justify-between lg:gap-16 lg:p-14"
        >
          <div className="flex max-w-[620px] flex-col gap-3">
            <h2 className="t-panel-title text-fg-inverse">{title}</h2>
            <p className="font-body text-[16px] leading-[1.65] text-fg-inverse-secondary sm:text-[17px]">
              {body}
            </p>
          </div>
          <div className="shrink-0">
            <Button to={cta.to} variant="dark">
              {cta.label}
            </Button>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
